(() => {
  const selector = '[data-mobile-autoplay-marquee]';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setupMarquee(scroller) {
    if (!scroller || scroller.dataset.mobileAutoplayInitialized === 'true') return;
    scroller.dataset.mobileAutoplayInitialized = 'true';

    const track = scroller.firstElementChild;
    if (!track) return;

    const speed = Number.parseFloat(scroller.dataset.marqueeSpeed || '0.5');
    const resumeDelay = 2800;
    let paused = false;
    let resumeTimer = 0;
    let lastTime = 0;
    let virtualScroll = scroller.scrollLeft;

    const clearResume = () => {
      if (!resumeTimer) return;
      window.clearTimeout(resumeTimer);
      resumeTimer = 0;
    };

    const pause = () => {
      paused = true;
      virtualScroll = scroller.scrollLeft;
      clearResume();
    };

    const resumeLater = () => {
      clearResume();
      resumeTimer = window.setTimeout(() => {
        virtualScroll = scroller.scrollLeft;
        paused = false;
        lastTime = performance.now();
      }, resumeDelay);
    };

    const startInteraction = () => {
      if (!mobileQuery.matches) return;
      pause();
    };

    const endInteraction = () => {
      if (!mobileQuery.matches) return;
      virtualScroll = scroller.scrollLeft;
      resumeLater();
    };

    const getLoopWidth = () => track.scrollWidth / 2;

    const normalizeLoop = () => {
      const loopWidth = getLoopWidth();
      if (loopWidth <= 0) return;

      if (virtualScroll >= loopWidth) {
        virtualScroll -= loopWidth;
        scroller.scrollLeft = virtualScroll;
      } else if (virtualScroll < 0) {
        virtualScroll += loopWidth;
        scroller.scrollLeft = virtualScroll;
      }
    };

    const tick = (time) => {
      if (!lastTime) lastTime = time;
      const delta = Math.min(time - lastTime, 50);
      lastTime = time;

      const canMove =
        mobileQuery.matches &&
        !reducedMotionQuery.matches &&
        !paused &&
        !document.hidden &&
        scroller.scrollWidth > scroller.clientWidth + 1;

      if (canMove) {
        // Keep a floating-point position. Reading scrollLeft every frame can round
        // sub-pixel movement back to zero on mobile browsers.
        virtualScroll += speed * (delta / 16.667);
        scroller.scrollLeft = virtualScroll;
        normalizeLoop();
      }

      window.requestAnimationFrame(tick);
    };

    scroller.addEventListener('pointerdown', startInteraction, { passive: true });
    scroller.addEventListener('pointerup', endInteraction, { passive: true });
    scroller.addEventListener('pointercancel', endInteraction, { passive: true });
    scroller.addEventListener('touchstart', startInteraction, { passive: true });
    scroller.addEventListener('touchend', endInteraction, { passive: true });
    scroller.addEventListener('touchcancel', endInteraction, { passive: true });
    scroller.addEventListener('wheel', () => {
      startInteraction();
      resumeLater();
    }, { passive: true });
    scroller.addEventListener('scroll', () => {
      if (paused) virtualScroll = scroller.scrollLeft;
    }, { passive: true });
    scroller.addEventListener('focusin', startInteraction);
    scroller.addEventListener('focusout', endInteraction);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        virtualScroll = scroller.scrollLeft;
        lastTime = performance.now();
      }
    });

    const handleModeChange = () => {
      clearResume();
      paused = false;
      lastTime = performance.now();
      if (!mobileQuery.matches) scroller.scrollLeft = 0;
      virtualScroll = scroller.scrollLeft;
    };

    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', handleModeChange);
    else mobileQuery.addListener(handleModeChange);

    window.requestAnimationFrame(tick);

    scroller.addEventListener('shopify:block:select', startInteraction);
    scroller.addEventListener('shopify:block:deselect', endInteraction);
  }

  function init(root = document) {
    root.querySelectorAll(selector).forEach(setupMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
